import { render, staticRenderFns } from "./log-links.vue?vue&type=template&id=37024f3d&scoped=true&"
import script from "./log-links.vue?vue&type=script&lang=js&"
export * from "./log-links.vue?vue&type=script&lang=js&"
import style0 from "./log-links.vue?vue&type=style&index=0&id=37024f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37024f3d",
  null
  
)

export default component.exports